import { AutoComplete, Form, Input } from 'antd';
import { Search } from 'lucide-react';
import { SEARCH_INPUT_PROPS } from '../../../../../shared/policies/search-input-props';
import { placeSearchEmptyMessage, placeSearchOptions, placeSearchPick } from '../../../../zones/public/place-search-options';
import { usePlaceSearch } from '../../../../zones/public/use-place-search';

/**
 * No truck is ever driven to a supplier, so there is no map pin — but typing the location still searches the
 * same place list a garage's map does (gitaumoses4/chukua#173), and picking a result fills the Location field
 * below with its full address. Typing the location by hand works exactly as before.
 */
export function SupplierLocationSearch() {
  const form = Form.useFormInstance();
  const search = usePlaceSearch(null, { includeZones: false });

  function select(option: string) {
    const pick = placeSearchPick(option, search.state);
    search.setText('');
    if (pick?.type !== 'place') return;
    form.setFieldsValue({ location: [pick.place.name, pick.place.context].filter(Boolean).join(', ') });
  }

  return (
    <AutoComplete
      className="w-full"
      value={search.text}
      options={placeSearchOptions(search.state)}
      onSearch={search.setText}
      onSelect={select}
      notFoundContent={placeSearchEmptyMessage(search.state, 'Type the location below instead.')}
    >
      <Input
        {...SEARCH_INPUT_PROPS}
        aria-label="Find the location"
        prefix={<Search className="size-4 text-muted" />}
        placeholder="Search by business, site or town"
      />
    </AutoComplete>
  );
}
